import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["image"]

  open() {
    const overlay = document.createElement("div")
    overlay.className = "lightbox-overlay"
    overlay.setAttribute("role", "dialog")
    overlay.setAttribute("aria-modal", "true")

    const img = document.createElement("img")
    img.src = this.imageTarget.currentSrc || this.imageTarget.src
    img.alt = this.imageTarget.alt

    overlay.appendChild(img)
    overlay.addEventListener("click", () => this.close(overlay))
    this.keydownHandler = (event) => {
      if (event.key === "Escape") this.close(overlay)
    }
    document.addEventListener("keydown", this.keydownHandler)

    document.body.appendChild(overlay)
  }

  close(overlay) {
    document.removeEventListener("keydown", this.keydownHandler)
    overlay.remove()
  }
}
